<div class="u-shadow-mini" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap primary-color-bg"
		>
			<div class="o-stack__cell">
				<h5>
					{{ sectiontitle }}
					<span *ngIf="hasData">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV()"
							*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
						>
							<img class="downloadIcon" src="{{ downloadIcon }}" />
						</a>
					</span>
				</h5>
			</div>
		</div>
		<div [ngClass]="sectionclass != '' ? sectionclass : 'analytics-portlet-content'">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="donut-chart-container">
					<div class="donut-legend-div" *ngIf="hasData">
						<div
							*ngFor="let legendItem of metricsArray; let i = index"
							class="legend-div"
							[ngStyle]="{ 'background-color': colorPalette.tertiaryColor }"
							[ngClass]="currentLegend != legendItem.valueKey ? 'devices-r7 legend-inactive' : ''"
							(click)="updateLegendData(legendItem.valueKey)"
						>
							<span class="legendName">{{ legendItem.title }}</span>
						</div>
					</div>
					<div class="outer-div" *ngIf="hasData">
						<div
							class="inner-div"
							[ngClass]="donutOptions.isCTV ? 'bigger-donut' : ''"
							*ngFor="let donut of currentChartData; let i = index"
						>
							<div class="deviceName">{{ donut.deviceName }}</div>
							<div class="{{ sectionclass }}backgroundBar">
								<div
									class="foreGroundBar"
									[ngStyle]="{
										width: (donut.percentage > 0 && donut.percentage < 0.025 ? 0.025 : donut.percentage) + '%',
										'background-color': getColorFromColorConfig(i, 1)
									}"
								></div>
							</div>
							<div
								class="donut-value primary-color"
								[ngClass]="
									donutOptions.isCTV ? 'bigger-donut-value' : donut.title == 'Cost' ? 'sem-donut-percentage' : ''
								"
							>
								{{ donut.percentage | number: '0.2-2' }}%
							</div>
							<div
								class="donut-title"
								[ngClass]="donut.title == 'Cost' ? 'sem-donut-value' : ''"
								*ngIf="!donutOptions?.isCTV"
							>
								{{ donut.value }} {{ donut.title }}
							</div>
						</div>
					</div>
					<div *ngIf="!hasData" class="no-data-min-ht">
						<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
							{{ nodatamessage }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
